import React from "react";
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { ThemeProvider, CssBaseline } from "@mui/material";
import { AuthProvider } from "./auth/AuthContext";
import { ApiProvider } from "./api/ApiContext";
import theme from "./theme";
import Login from "./pages/Login";
import Register from "./pages/Register";
import Profile from "./pages/Profile";
import Upload from "./pages/Upload";
import ProtectedRoute from "./auth/ProtectedRoute";
import Navbar from "./components/Navbar";
import Gallery from "./pages/Gallery";
import Favorites from "./pages/Favorites";
import SharedFavorites from "./pages/SharedFavorites";
import { Box } from "@mui/material";

function AppContent() {
  const location = useLocation();
  const isShared = location.pathname.startsWith("/shared-favorites");

  return (
    <>
      <Navbar />
      <Box
        component="main"
        sx={{
          mt: {
            xs: "calc(52px + env(safe-area-inset-top))",
            sm: "calc(64px + env(safe-area-inset-top))",
          },
          pb: {
            xs: "calc(56px + env(safe-area-inset-bottom))",
            sm: 0,
          },
          minHeight: "100dvh",
        }}
      >
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/profile" element={<ProtectedRoute><Profile /></ProtectedRoute>} />
          <Route path="/gallery" element={<ProtectedRoute><Gallery /></ProtectedRoute>} />
          <Route path="/favorites" element={<ProtectedRoute><Favorites /></ProtectedRoute>} />
          <Route path="/shared-favorites/:token" element={<SharedFavorites />} />
          <Route path="/upload" element={<Upload />} />
          <Route path="*" element={<Navigate to="/login" />} />
        </Routes>
      </Box>
    </>
  );
}

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <ApiProvider>
        <AuthProvider>
          <Router>
            <AppContent />
          </Router>
        </AuthProvider>
      </ApiProvider>
    </ThemeProvider>
  );
}

export default App;
